import { createSelector } from '@reduxjs/toolkit';

import { RootState } from './store';

export const associationsSelector = (state: RootState) => state.associations.associations;
export const moreAssociationsLoadingSelector = (state: RootState) => state.associations.moreAssociationsLoading;
export const associationsErrorSelector = (state: RootState) => state.associations.associationsError;
export const noMoreAssociationsSelector = (state: RootState) => state.associations.noMoreAssociations;
export const randomSelector = (state: RootState) => state.associations.random;
export const associationsLoadingSelector = createSelector(associationsSelector, associations => {
	return associations === null;
});